import React, {Component} from 'react'
import {connect} from 'react-redux'
import { Button } from 'semantic-ui-react'
import API_Root from "../../../../Constants/API_Root";
import getURLParam from "../../../../Constants/getURLParam";
import {modifyCustomImportSettings} from "../../../../Actions/ModifyCustomImportSettings";

class SaveAppearanceBtn extends Component {
    constructor(props) {
        super(props);

        this.state = {
            saving: false
        }
    }

    save = () => {
        this.setState({saving: true});

        const error = () => {
            this.setState({saving: false})
            alert("There was an error saving your appearance settings. Please try again. Contact our support if this persists")
        }

        const splitParam = getURLParam(window.location.href).split("_")
        const importKey = splitParam[0];

        const appearanceCopy = JSON.parse(JSON.stringify(this.props.customImportAppearanceEdit))

        fetch(API_Root + "api/update-import-details/", {
            method: "POST",
            body: JSON.stringify({
                email: localStorage.getItem("email"),
                token: localStorage.getItem("token"),
                importHash: importKey,
                changeObject: {appearance: appearanceCopy}
            })
        }).then((res) => {
            if (res.status === 200) {
                this.updateDestinationsInRedux()
            }
            else {
                error()
            }
        }).catch(err => error())
    }

    updateDestinationsInRedux = () => {
        const appearance = JSON.parse(JSON.stringify(this.props.customImportAppearance))

        for (let key in this.props.customImportAppearanceEdit){
            appearance[key] = this.props.customImportAppearanceEdit[key]
        }

        this.props.modifyCustomImportSettings("appearance", appearance)

        this.setState({ saving: false })
    }

    render() {
        return (
            <div>
                <Button
                    loading={this.state.saving}
                    content="Save Appearance"
                    icon="save alternate outline"
                    color="green"
                    onClick={this.save}
                    disabled={!this.props.hasInfoChanged}
                    fluid
                />
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    customImportAppearance: state.mainState.customImportAppearance,
    customImportAppearanceEdit: state.mainState.customImportAppearanceEdit
})

const mapActionsToProps = {
    modifyCustomImportSettings: modifyCustomImportSettings
}

export default connect(mapStateToProps, mapActionsToProps)(SaveAppearanceBtn)